<ion-content class="theme-{{userService.theme}}">
    <ion-header>
        <app-header></app-header>
    </ion-header>
<div class="form-wrap content-wrap">
    <div *ngIf="type !== 'self'" [@enter] class="title my-color-blue">{{'__SC_FORM_TITLE_MANAGER__' | translate}} <span *ngIf="dataForm !== null" [@enter]>({{dataForm.delegate.fullname}})</span></div>
    <div *ngIf="type === 'self'" [@enter] class="title my-color-blue">{{'__SC_FORM_TITLE_LEARNER__' | translate}}</div>

    <div *ngIf="type === 'self'" [@enter] class="text" [innerHTML]="'__SC_SUMMARY_DESC_LEARNER__' | translate"></div>
    <div *ngIf="type === 'manager'" [@enter] class="text" [innerHTML]="'__SC_SUMMARY_DESC_MANAGER__' | translate"></div>
    <div *ngIf="type === 'agreed'" [@enter] class="text" [innerHTML]="'__SC_SUMMARY_DESC_AGREED__' | translate"></div>

    <div [@enter] class="lines">
        <div class="item"><span class="my-color-blue">1</span> - {{'__SC_SUMMARY_RATE_DESC1__' | translate}}</div>
        <div class="item"><span class="my-color-blue">2</span> - {{'__SC_SUMMARY_RATE_DESC2__' | translate}}</div>
        <div class="item"><span class="my-color-blue">3</span> - {{'__SC_SUMMARY_RATE_DESC3__' | translate}}</div>
        <div class="item"><span class="my-color-blue">4</span> - {{'__SC_SUMMARY_RATE_DESC4__' | translate}}</div>
        <div class="item"><span class="my-color-blue">5</span> - {{'__SC_SUMMARY_RATE_DESC5__' | translate}}</div>
        <div class="item"><span class="my-color-blue">N/A</span> - {{'__SC_SUMMARY_RATE_DESC6__' | translate}}</div>
    </div>

    <div [@enter] class="line" *ngIf="dataForm !== null">
        <span *ngIf="type === 'self'" class="my-color-blue">{{'__SC_SUMMARY_QUESTIONS_SELF__' | translate}}:</span>
        <span *ngIf="type === 'manager'" class="my-color-blue">{{'__SC_SUMMARY_QUESTIONS_MANAGER__' | translate}}:</span>
        <span *ngIf="type === 'agreed'" class="my-color-blue">{{'__SC_SUMMARY_QUESTIONS_AGREED__' | translate}}:</span>
        <span >({{dataForm.questions.value.length}} {{'__SC_SUMMARY_TOTAL__' | translate}})</span>
    </div>

    <div class="list" *ngIf="dataForm !== null">

        <div  *ngFor="let question of dataForm.questions.value; let i = index;"
             [@leave]>
            <div class="competency theme-bnw primary-bg-color" *ngIf="isAlreadyHappened(question.competency)">
                {{ question.competency }}</div>
            <div class="item">
                <div class="number my-color-blue">{{i + 1}}.</div>
                <div class="content">
                    <div class="text">
                        {{ question.question }}
                    </div>
                    <app-radio-group *ngIf="type === 'self'" [items]="radioGroup"
                                    [(value)]="question.q_value_self.value"></app-radio-group>
                    <app-radio-group *ngIf="type === 'manager'" [items]="radioGroup"
                                    [(value)]="question.q_value_manager.value"></app-radio-group>
                    <app-radio-group *ngIf="type === 'agreed'" [items]="radioGroup"
                                    [(value)]="question.q_value_agreed.value"
                                    [highlight]="question.q_value_manager.value"></app-radio-group>
                </div>
            </div>
        </div>
    </div>

    <div class="list" *ngIf="dataForm === null">
        <div class="line" >
            <span class="my-color-blue"><ion-skeleton-text animated style="width: 7rem;"></ion-skeleton-text></span>
            <span ><ion-skeleton-text animated style="width: 5rem;"></ion-skeleton-text></span>
        </div>

        <div class="item" *ngFor="let question of [1,2,3,4]">
            <div class="number my-color-blue">
                <ion-skeleton-text animated style="height: 2rem; width: 2rem;"></ion-skeleton-text>
            </div>
            <div class="content">
                <div class="text">
                    <ion-skeleton-text animated></ion-skeleton-text>
                    <ion-skeleton-text animated></ion-skeleton-text>
                    <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
                </div>
                <ion-skeleton-text animated style="height: 2.3rem;"></ion-skeleton-text>
            </div>
        </div>
    </div>

    <div class="comments" *ngIf="dataForm !== null">
    <div class="text-grey-light-title my-color-blue smaller">{{'__SC_FORM_LEARNER_COMMENTS__' | translate}}</div>
    <textarea [disabled]="type != 'self'" (change)="onChange($event)" aria-label=""
              [(ngModel)]="dataForm.comments.value"></textarea>

    <div class="text-grey-light-title my-color-blue smaller">{{'__SC_FORM_MANAGER_COMMENTS__' | translate}}</div>
    <textarea [disabled]="type == 'self'" (change)="onChange($event)" aria-label=""
              [(ngModel)]="dataForm.comments_manager.value"></textarea>
    </div>
</div>
</ion-content>
<ion-footer>
    <app-footer (saveEvent)="onSave()" [backButton]="true" [saveButton]="true"></app-footer>
</ion-footer>
